module.exports = __webpack_public_path__ + "static/media/video-off.6a30496f.svg";